import Layout from '@/layout/layout'

const featureRouter = {
  path: '/outgoManagement',
  component: Layout,
  redirect: 'noRedirect',
  name: '旧机出库',
  children: [
    {
      path: 'createWarehouse',
      component: () => import('@/views/outgoManagement/createWarehouse/index'),
      name: '创建出库',
      meta: { title: '创建出库', noCache: true,keepAlive: false}
    },
    {
      path: 'outboundDocument',
      component: () => import('@/views/outgoManagement/outboundDocument/index'),
      name: '出库单据',
      meta: { title: '出库单据', noCache: true}
    },
    {
      path: 'documentParticulars',
      component: () => import('@/views/outgoManagement/documentParticulars/index'),
      name: '单据详情',
      meta: { title: '单据详情', noCache: true}
    },
  ]
}

export default featureRouter
